import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	securityFieldHeadingTitle: {
		id: 'development-summary-security-field.security-field-heading-title',
		defaultMessage: 'Security',
		description: 'The security field heading title.',
	},
});
